var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],class:{'disabled': _vm.disabled},style:(_vm.style),attrs:{"rows":"10","cols":"30"},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing)return;_vm.text=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }